import { Plus, Minus, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ZoomControlProps {
  dynamicZoom: number;
  onZoom: (zoom: number) => void;
  resetCompass: () => void;
}

export const ZoomControl = (props: ZoomControlProps) => {
  return (
    <div className="flex flex-col gap-2 self-end">
      <div className="flex flex-col items-center justify-center self-end w-10 rounded-md bg-popover shadow-md">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => props.onZoom(props.dynamicZoom + 0.5)}
        >
          <Plus className="size-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => props.onZoom(props.dynamicZoom - 0.5)}
        >
          <Minus className="size-4" />
        </Button>
      </div>
      <div className="flex items-center justify-center self-end w-10 h-10 rounded-md bg-popover shadow-md">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => props.resetCompass()}
        >
          <Compass className="size-4" />
        </Button>
      </div>
    </div>
  );
};
